module.exports = __webpack_public_path__ + "static/media/19_Samuel_L@3x.81fd2c4b.jpg";